import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import { Edit, Trash, More } from "@rsuite/icons";
import BlockRoundIcon from "@rsuite/icons/BlockRound";
import CheckRoundIcon from "@rsuite/icons/CheckRound";
import React, { useRef, useState } from "react";
import { Popover, Dropdown, IconButton, Whisper } from "rsuite";
import ViewStoreModal from "./ViewStore";
import { useDispatch } from "react-redux";
import { setActionData } from "../../../redux/userActionData";
import { useNavigate } from "react-router-dom";
import { roleObjArr, statusArr } from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";
import UserForCompany from "../Users/UserForCompany";
import UserForStore from "../Users/UserForStore";
import ViewStoreProductsModal from "../Products/ViewStoreProducts";

const StoreSingleAction = ({
  storeData,
  onDeleteStore,
  onPublishStore,
  permission,
  refreshList,
  ...props
}: {
  storeData: any;
  onDeleteStore: Function;
  onPublishStore: Function;
  permission: any;
  refreshList?: Function;
}) => {
  const { t } = useTranslation();
  const compRef = useRef({});
  const dispatch = useDispatch();
  const [openModalByName, setOpenModalByName] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const [publishMessage, setPublishMessage] = useState("");
  const ecryptedCompId = encryptUrl(`${storeData.id}`);

  const storeUpdateLink = ContentRoutes.UPDATE_STORE.replace(
    ":id",
    ecryptedCompId.toString()
  );

  const productImportLink = ContentRoutes.IMPORT_PRODUCTS_FOR_STORE.replace(
    ":id",
    ecryptedCompId.toString()
  );

  const navigate = useNavigate();
  const publishText =
    storeData.status == statusArr.active
      ? t("UNPUBLISH").toLowerCase()
      : t("PUBLISH").toLowerCase();
  const pMessage = t("CONFIRM_ACTION", {
    action:
      storeData.status == statusArr.active
        ? t("UNPUBLISH").toLowerCase()
        : t("PUBLISH").toLowerCase(),
    entity: t("STORE").toLowerCase(),
  });
  const publishIcon =
    storeData.status == statusArr.inactive ? (
      <BlockRoundIcon />
    ) : (
      <CheckRoundIcon />
    );

  const renderMenu = (
    {
      onClose,
      left,
      top,
      className,
    }: { onClose: any; left: any; top: any; className: any },
    ref:
      | ((instance: HTMLDivElement | null) => void)
      | React.RefObject<HTMLDivElement>
      | null
      | undefined
  ) => {
    const handleSelect = (eventKey: any) => {
      if (eventKey == "import-product") {
        handleProductImportAction();
      } else {
        setOpenModalByName(eventKey);
        dispatch(setActionData(storeData));
      }
      onClose();
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={"view-store"}>{t("VIEW")}</Dropdown.Item>
          {permission.create_user && (
            <Dropdown.Item eventKey={"set-primary-user"}>
              {storeData?.primary_user_id
                ? t("UPDATE") + " " + t("PRIMARY") + " " + t("MANAGER")
                : t("CREATE") + " " + t("PRIMARY") + " " + t("MANAGER")}
            </Dropdown.Item>
          )}

          {permission.import_product && (
            <Dropdown.Item eventKey={"import-product"}>
              {t("IMPORT") + " " + t("PRODUCT")}
            </Dropdown.Item>
          )}

          {permission.view_store_product && (
            <Dropdown.Item eventKey={"view-imported-products"}>
              {t("VIEW") + " " + t("STORE") + " " + t("PRODUCT")}
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Popover>
    );
  };

  function handleEditAction() {
    navigate(`${storeUpdateLink}`);
  }

  function handleProductImportAction() {
    navigate(`${productImportLink}`);
  }

  function onCompleteStoreManager() {
    if (refreshList) refreshList();
  }

  return (
    <div>
      {permission.update && (
        <>
          <IconButton
            appearance="subtle"
            onClick={handleEditAction}
            title={t("UPDATE")}
            icon={<Edit />}
          />
        </>
      )}
      {permission.delete && (
        <>
          <IconButton
            onClick={() => {
              compRef.current = storeData;
              setOpenDeleteModal(true);
            }}
            icon={<Trash />}
            title={t("DELETE")}
            size="md"
          />
        </>
      )}
      {permission.publish && (
        <>
          <IconButton
            onClick={() => {
              compRef.current = storeData;
              setOpenPublishModal(true);
              setPublishMessage(pMessage);
            }}
            icon={publishIcon}
            title={publishText}
            size="md"
          />
        </>
      )}
      <Whisper
        placement="topEnd"
        trigger="click"
        speaker={renderMenu}
        preventOverflow={true}
      >
        <IconButton appearance="subtle" icon={<More />} />
      </Whisper>
      {openModalByName === "view-store" && (
        <ViewStoreModal
          status={openModalByName === "view-store" ? true : false}
          toggle={setOpenModalByName}
        />
      )}
      {openModalByName === "set-primary-user" && storeData.id && (
        <UserForStore
          storeId={storeData.id}
          openModal={true}
          setOpenModal={setOpenModalByName}
          onComplete={onCompleteStoreManager}
        />
      )}
      {openModalByName === "view-imported-products" && (
        <ViewStoreProductsModal
          storeId={storeData.id}
          openModal={true}
          setOpenModal={setOpenModalByName}
        />
      )}
      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onDeleteStore(compRef);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("STORE").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("DELETE").toLowerCase(),
        })}
      />
      <AlertModal
        open={openPublishModal}
        handleClose={(e: any) => {
          if (e == true) {
            onPublishStore(compRef);
            setOpenPublishModal(false);
          } else {
            setOpenPublishModal(false);
          }
        }}
        displayText={publishMessage}
      />
    </div>
  );
};

export default StoreSingleAction;
